import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('Organisations');

export const organisationQueries = {
  selectAll: baseQuery
};
